import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  container: {
    // border: '1px solid rgba(233, 235, 245, 1)',
    borderRadius: '4px',
    // padding: '24px',
    // display: 'flex',
    flexDirection: 'column',
    // gap: '24px',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none !important',
    },
    scrollbarWidth: 'none !important',
    msOverflowStyle: 'none !important',
    // maxHeight: 'calc(100vh - 140px)',
    // minHeight: 'calc(100vh - 140px)',
    backgroundColor: '#fff',
  },

  row: {
    height: '44px',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    display: 'flex',
    gap: '16px',
    padding: '10px 0px',
    // border: '1px solid rgba(233, 235, 245, 0.7)',
    borderRadius: 6,
    alignItems: 'center',
  },

  dateBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '150px',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',

  },

  dateText: {
    fontSize: '12px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: 'rgba(95, 96, 113, 1)',
  },

  iconWrapper: {
    width: '32px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

  },

  iconCircle: {
    width: '32px',
    height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid rgba(233, 235, 245, 1)',
    borderRadius: '50px',
    backgroundColor: 'rgba(250, 250, 254, 1)',
    padding: '5px',
  },

  messageBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'start',
    flexGrow: 1,
    minWidth: 0, // allow ellipsis if added later
  },

  messageText: {
    fontSize: '14px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: 'rgba(43, 44, 53, 1)',
    flexGrow: 1,
  },

  userText: {
    fontSize: '12px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: 'rgba(95, 96, 113, 1)',
    flexGrow: 1,

  },

  noAudit: {
    textAlign: 'center',
    width: '100%',
    padding: '20px',
  },
}));

import {

  Tooltip,
  Button,
  createStyles,
} from '@material-ui/core'

import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator
} from '@material-ui/lab'

import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined'
import ArrowUpwardOutlinedIcon from '@material-ui/icons/ArrowUpwardOutlined'
import AutorenewOutlinedIcon from '@material-ui/icons/AutorenewOutlined'
import ChatOutlinedIcon from '@material-ui/icons/ChatOutlined'
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined'
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined'
import HistoryOutlinedIcon from '@material-ui/icons/HistoryOutlined'
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import CloseIcon from '@material-ui/icons/Close';
import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined'
import RotateRightOutlinedIcon from '@material-ui/icons/RotateRightOutlined'
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined'

const useAuditTrailsStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
      height: 'calc(100vh - 232px)',
    },
    paper: {
      boxShadow: 'none',
      border: '1px solid #EEEEEE !important',
      borderTop: 'none !important'
    },
    header: {
      padding: theme.spacing(2, 3),
      borderBottom: `1px solid ${theme.palette.divider}`,
      textAlign: 'left'
    },
    timeline: {
      padding: '16px'
    },
    opposite: {
      padding: '0px !important',
      color: '#78798E',
      fontSize: '0.75rem',
      minWidth: 180,
      flex: 0.2,
      textAlign: 'left',
      alignContent: 'center'
    },
    title: {
      fontSize: '0.875rem',
      lineHeight: '1.75rem',
      color: '#2B2C35',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
      display: 'block',
    },
    subtitle: {
      marginTop: 8,
      color: '#78798E',
      fontSize: '0.75rem'
    },
    connector: {
      width: 1,
      background: 'linear-gradient(180deg, #D5D6DD 60%, transparent 40%)',
      backgroundSize: '2px 8px'
    },
    content: {
      textAlign: 'left',
      minWidth: 0,
    },
    dot: {
      height: '1.5rem',
      width: '1.5rem',
      boxShadow: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%'
    }
  })
)

const getIcon = ({ operation, formName, formType }) => {
  let icon
  let bgColor

  switch (true) {
    case operation === 'process':
      bgColor = '#7A00FF'
      icon = <SettingsOutlinedIcon />
      break

    case operation === 'Created':
      bgColor = '#7A00FF'
      icon = <SettingsOutlinedIcon />
      break

    case operation === 'Accept':
      bgColor = '#27B47C'
      icon = <CheckOutlinedIcon />
      break

    case operation === 'Complete':
      bgColor = '#27B47C'
      icon = <CheckOutlinedIcon />
      break

    case operation === 'Modify' &&
      formName === 'workflow' &&
      formType === 'Init':
      bgColor = '#3082AA'
      icon = <RotateRightOutlinedIcon />
      break

    case operation === 'Modify' &&
      formName === 'workflow' &&
      formType === 'ReInit':
      bgColor = '#0095FF'
      icon = <AutorenewOutlinedIcon />
      break

    case operation === 'Modify' &&
      formName === 'workflow' &&
      formType === 'Comment':
      bgColor = '#8E8E8E'
      icon = <ChatOutlinedIcon />
      break

    case operation === 'Modify' &&
      formName === 'workflow' &&
      formType === 'Execute':
      bgColor = '#27B47C'
      icon = <CheckOutlinedIcon />
      break

    case operation === 'Modify' &&
      formName === 'workflow' &&
      formType === 'Reject':
      bgColor = '#F52F55'
      icon = <ClearOutlinedIcon />
      break

    case operation === 'Update':
      bgColor = '#ED6A30'
      icon = <EditOutlinedIcon />
      break

    case operation === 'Assign document':
      bgColor = '#FEAD2C'
      icon = <PersonAddOutlinedIcon />
      break

    case operation === 'Moved':
      bgColor = '#523FFF'
      icon = <ArrowForwardOutlinedIcon />
      break

    case operation === 'Upload':
      bgColor = '#FF3FEC'
      icon = <ArrowUpwardOutlinedIcon />
      break

    case operation === 'filesplit':
      bgColor = '#BF00FF'
      icon = <FileCopyOutlinedIcon />
      break

    case operation === 'UnLocked':
      bgColor = '#27B47C'
      icon = <LockOpenOutlinedIcon />
      break

    case operation === 'Restore':
      bgColor = '#C7317E'
      icon = <HistoryOutlinedIcon />
      break

    case operation === 'Locked':
      bgColor = '#526172'
      icon = <LockOutlinedIcon />
      break

    case operation === 'Delete':
      bgColor = '#FE2C2C'
      icon = <CloseIcon />
      break

    default:
      bgColor = '#f5f5f5'
      icon = '🔄'
  }

  return {
    icon,
    bgColor
  }
}

const EventItem = (props) => {
  const { e, last } = props
  const classes = useAuditTrailsStyles()

  const legend = getIcon({
    operation: e?.operation,
    formName: e?.formName,
    formType: e?.formType
  })

  return (
    <TimelineItem>
      <TimelineOppositeContent className={classes.opposite}>
        {new Date(e.createdDate?.trim()).toLocaleString()}
      </TimelineOppositeContent>
      <TimelineSeparator style={{ marginTop: '0px' }}>
        <TimelineDot
          className={classes.dot}
          style={{ backgroundColor: legend?.bgColor }}
        >
          {legend?.icon}
        </TimelineDot>
        {!last && <TimelineConnector className={classes.connector} />}
      </TimelineSeparator>
      <TimelineContent className={classes.content}>
        <Tooltip title={e.message}>
          <Typography className={classes.title}>{e.message}</Typography>
        </Tooltip>
        <Typography className={classes.subtitle}>By {e.userName}</Typography>
      </TimelineContent>
    </TimelineItem>
  )
}



const AuditTrailViewer = (props) => {
  const { auditTrail, chartUniqueId } = props;
  const classes = useStyles();
  const classess = useAuditTrailsStyles()

  const getOperationIcon = (formName, operation, formType) => {
    const operationIcons = {
      Created: '/media/svg/AddTaskObligationAudit.svg',
      taskCreated: '/media/svg/AddTaskObligationAudit.svg',
      Accept: '/media/svg/tickObligations.svg',
      "Assign document": '/media/svg/assignedObligationAudit.svg',
      assigned: '/media/svg/assignedObligationAudit.svg',
      deleted: '/media/svg/deleteTaskAudit.svg',
      taskUpdated: '/media/svg/editObligationAudit.svg',
      forwarded: '/media/svg/forwardObligationAudit.svg',
      messaged: '/media/svg/messageObligationAudit.svg',
      Modify: '/media/svg/moveObligationsAudit.svg',
      rejectObligation: '/media/svg/tickObligations.svg',
      taskDelete: '/media/svg/deleteTaskAudit.svg',
    };

    if (operation === 'Modify' && formType === "Reject") {
      return operationIcons["rejectObligation"]
    }
    if (formName === "workflow" && formType === "Comment") {
      return operationIcons["messaged"]
    }
    return operationIcons[operation];
  }

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const formatted = date.toLocaleString("en-US", {
      month: "numeric",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return formatted.replace(/\//g, "-");
  }

  console.log(auditTrail ** props, 'auditTrail')

  return (
    <div className={`${classes.container} myScrollContainer`}>
      <div style={{ height: '70px', boxSizing: 'border-box', padding: '10px 16px', display: 'flex', alignItems: 'center', justifyContent: 'start', borderBottom: '1px solid #E0E0E0' }}>
        <Typography style={{ fontSize: '14px', fontWeight: '500', color: 'rgba(43, 44, 53, 1)', fontStyle: 'normal', lineHeight: '21px' }}>
          Audit trails
        </Typography>
      </div>
      <div style={{ padding: '10px 16px', boxSizing: 'border-box', minHeight: 'calc(100vh - 140px)', maxHeight: 'calc(100vh - 140px)', borderBottom: '1px solid #E0E0E0', overflowY: 'auto'}}>
        {props.formData?.[chartUniqueId + '_audit_Trails_Obligations_loading'] ? (
          props.loader
        ) : auditTrail && auditTrail.length > 0 ? (
          <Timeline align='left' style={{ padding: '0px' }}>
            {
              auditTrail.map((res, index) => (
                <EventItem
                  key={`auditlog-${res._id}`}
                  e={res}
                  last={index === auditTrail.length - 1}
                />
              ))
            }
          </Timeline>
        ) : (
          <Typography className={`${classes.messageText} ${classes.noAudit}`}>
            No audit history available yet.
          </Typography>
        )}
      </div>
      <div style={{ height: '70px', boxSizing: 'border-box', padding: '10px 16px', display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
        <Button
          style={{ color: '#3F51B5', border: '1px solid #3F51B5', borderRadius: '4px', height: '35px', padding: '12px', boxSizing: 'border-box' }}
          onClick={props.handleAuditTrailDrawerToggle}
        >
          Close
        </Button>
      </div>
    </div>
  );
}

export default AuditTrailViewer
